module.exports = __webpack_public_path__ + "img/cnimg2.37ee01a3.png";